import {showLoading, hideLoading, showAlert} from '@/utils/tools'
import api from '@/api'
import { Dialog } from 'vant'
import store from '@/store'
import Vue from 'vue'
import router from '@/router'

export const checkOrderState = async (callback, isTravelPage) => {
  const hasCallback = typeof callback === 'function'
  await checkLoginStatus()
  showLoading()
  const { errCode, errMsg, data } = await api.checkOrderStatus()
  hideLoading()
  if (errCode === 0) {
    if (data.orderStatus === 1 && !data.orderIsInChange) {
      Dialog.confirm({
        // isTravelPage为true时，页面在超凡观光页面
        message: isTravelPage ? '选择新路线将替换原有路线' : '您已有提交的订单，是否需要新增活动',
        beforeClose: async (action, done) => {
          if (action === 'confirm') {
            const editOrder = await api.editOrder()
            done()
            await Vue.nextTick()
            store.commit('store', {
              showCartCancelOrder: false
            });
            console.log('editOrder-showCartCancelOrder--'+store.state.showCartCancelOrder);
            router.push('/page_shopping_cart');
            if (hasCallback) callback(editOrder.errCode === 0 ? '' : editOrder.errMsg)
          } else {
            if (hasCallback) callback('cancel')
            done()
          }
        }
      })
    } else {
      if (hasCallback) callback('', data.orderStatus, data.orderIsInChange, data.canCancelOrder)
    }
  } else {
    if (hasCallback) callback(errMsg)
  }
}

export const getShoppingCartNum = async callback => {
  const { errCode, errMsg, data } = await api.getShoppingCartCount()
  if (errCode === 0) {
    if(data) {
      store.commit('store', {
        goodsCartNum: data
      })
    } else {
      store.commit('store', {
        goodsCartNum: 0
      })
    }
    // if (data && data.selectedShorex === 0 && (data.shopCartItems === null || data.shopCartItems.length === 0)) {
    //   store.commit('store', {
    //     goodsCartNum: 0
    //   })
    // } else {
    //   // cartNumber = data.shopCartItems.length
    //   data.shopCartItems.forEach(item => {
    //     cartNumber = cartNumber + item.qty
    //   })
    //   if (data.selectedShorex !== 0) {
    //     cartNumber++
    //   }
    //   store.commit('store', {
    //     goodsCartNum: cartNumber
    //   })
    // }
  } else {
    store.commit('store', {
      goodsCartNum: 0
    })
    if (typeof callback === 'function') callback(errMsg)
  }
}

export const getSmShoppingCartNum = async callback => {
  try {
    const {
      errCode,
      errMsg,
      data
    } = await api.getSmShoppingCartsList()
    let cartNumber = 0
    if (errCode === 0) {
      if (data && data.Items.length === 0) {
        store.commit('store', {
          smCartNum: 0
        })
      } else {
        data.Items.forEach(item => {
          cartNumber = cartNumber + item.ShoppingCartItemModel.Quantity
        })
        store.commit('store', {
          smCartNum: cartNumber
        })
      }
    } else {
      store.commit('store', {
        smCartNum: 0
      })
      if (typeof callback === 'function') callback(errMsg)
    }
  } catch (error) {
    console.log('getSmShoppingCartsList-error', error)
  }
}

export const checkLoginStatus = () => {
  return new Promise(resolve => {
    if (!store.getters.isLogin || !store.state.bindTicket) {
      if (store.state.isMiniApp && !store.getters.isLogin) {
        // window.wx.miniProgram.navigateTo({ url: '/pages/authorize/authorize' })
        // window.wx.miniProgram.navigateTo({ url: `${process.env.VUE_APP_MINI_PROGRAM}/authorize/authorize` })
        window.wx.miniProgram.navigateTo({ url: `${sessionStorage.getItem('MINI_APP_URL')}/authorize/authorize` })
      } else {
        showAlert({
          message: store.getters.isLogin ? '请先绑定船票' : '请先登录并绑定船票',
          showCancelButton: true
        }).then(() => {
          if(store.getters.isLogin){
            router.push('/bind_ticket')
          }else {
            const campaignId=process.env.VUE_APP_API_KEY
            const viewSource= sessionStorage.getItem('ViewSource') ? sessionStorage.getItem('ViewSource') : 'pcp';
            const origin=process.env.VUE_APP_LOGIN_URL
            const path=location.href
            console.log(path,'path')
            const currentHref=encodeURI(path)
            const loginURL=`${origin}/Orchard.Rccl.Users/Login/Login?returnUrl=${currentHref}&campaignId=${campaignId}&viewSource=${viewSource}`
            console.log('loginURL',loginURL)
            console.log('viewSource', viewSource)
            window.location.href=loginURL
          }
        })
      }
    } else {
      resolve()
    }
  })
}

export const toShoppingMall = async page => {
  // showLoading()
  // const { errCode, errMsg, data } = await api.getUrlToShoppingMall(page || 'home')
  // hideLoading()
  // if (errCode === 0) {
  //   location.href = data
  // } else {
  //   showAlert(errMsg || '加载失败，请稍后重试')
  // }
  if (page === 'order') {
    window.location.href = process.env.VUE_APP_SM + 'SMCheckout/OrderForm'
  } else if (page === 'shoppingCart') {
    window.location.href = process.env.VUE_APP_SM + 'cart'
  } else {
    window.location.href = process.env.VUE_APP_SM
  }
}

export const bindGioTrack = params => {
  gioTracking('track', 'Add_ShoppingCart', {
    'Product_DetailProduct': params.productName,
    'Product_Category': params.productCategory,
    'product_ID': params.productId
  })
}

export const gioTracking = (type, eventName, eventObject) => {
  console.log(type, eventName, eventObject ? JSON.stringify(eventObject) : '')
  if (window && window.gio) {
    try {
      if (eventObject) {
        window.gio(type, eventName, eventObject)
      } else {
        window.gio(type, eventName)
      }
    } catch (e) {
      console.error(e)
    }
  }
}

export const gioAdsTracking = (eventObject) => {
  const event = {
    'adsType': eventObject.adsType || 'nil',
    'bnOrder': eventObject.bnOrder || 'nil',
    'stOrder': eventObject.stOrder || 'nil',
    'viewMore': eventObject.viewMore || 'nil',
    'etItem': eventObject.etItem || 'nil',
    'rcm': eventObject.rcm || 'nil',
    'mbnOrder': eventObject.mbnOrder || 'nil',
    'desUrl': eventObject.desUrl || 'nil'
  }
  gioTracking('track', 'evt_AdsClicked', event)
}


export const getUserName = ({ lastName, firstName, lastNamePinYin, firstNamePinYin, mobile }) => {
  if (lastName !== null && firstName !== null) {
    return `${lastName} ${firstName}`
  } else if (lastNamePinYin !== null && firstNamePinYin !== null) {
    return `${lastNamePinYin} ${firstNamePinYin}`
  } else {
    return mobile
  }
}
export const getGetAvailableCouponCount = async(callback) => {
  const { errCode, errMsg, data } = await api.getGetAvailableCouponCount()
  if (errCode === 0) {
    store.commit("SET_USER_COUPON", data)
  } else {
    store.commit("SET_USER_COUPON", null)
    if (typeof callback === 'function') callback(errMsg)
  }
}